/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shipping_Label_Mock_SuccessInputs */

const en_shipping_label_mock_success = /** @type {(inputs: Shipping_Label_Mock_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shipping Label Generated (Simulation)`)
};

const es_shipping_label_mock_success = /** @type {(inputs: Shipping_Label_Mock_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etiqueta Generada (Simulación)`)
};

const fr_shipping_label_mock_success = /** @type {(inputs: Shipping_Label_Mock_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Étiquette d'expédition générée (Simulation)`)
};

const de_shipping_label_mock_success = /** @type {(inputs: Shipping_Label_Mock_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versandetikett generiert (Simulation)`)
};

const id_shipping_label_mock_success = /** @type {(inputs: Shipping_Label_Mock_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Label Pengiriman Dibuat (Simulasi)`)
};

/** @type {(inputs: Shipping_Label_Mock_SuccessInputs) => LocalizedString} */
const ja_shipping_label_mock_success = en_shipping_label_mock_success;

/** @type {(inputs: Shipping_Label_Mock_SuccessInputs) => LocalizedString} */
const zh_shipping_label_mock_success = en_shipping_label_mock_success;

/** @type {(inputs: Shipping_Label_Mock_SuccessInputs) => LocalizedString} */
const ar_shipping_label_mock_success = en_shipping_label_mock_success;

/** @type {(inputs: Shipping_Label_Mock_SuccessInputs) => LocalizedString} */
const it_shipping_label_mock_success = en_shipping_label_mock_success;

/** @type {(inputs: Shipping_Label_Mock_SuccessInputs) => LocalizedString} */
const ru_shipping_label_mock_success = en_shipping_label_mock_success;

/** @type {(inputs: Shipping_Label_Mock_SuccessInputs) => LocalizedString} */
const pt_shipping_label_mock_success = en_shipping_label_mock_success;

/** @type {(inputs: Shipping_Label_Mock_SuccessInputs) => LocalizedString} */
const ko_shipping_label_mock_success = en_shipping_label_mock_success;

/**
* | output |
* | --- |
* | "Shipping Label Generated (Simulation)" |
*
* @param {Shipping_Label_Mock_SuccessInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const shipping_label_mock_success = /** @type {((inputs?: Shipping_Label_Mock_SuccessInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shipping_Label_Mock_SuccessInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shipping_label_mock_success(inputs)
	if (locale === "es") return es_shipping_label_mock_success(inputs)
	if (locale === "fr") return fr_shipping_label_mock_success(inputs)
	if (locale === "de") return de_shipping_label_mock_success(inputs)
	if (locale === "ja") return ja_shipping_label_mock_success(inputs)
	if (locale === "zh") return zh_shipping_label_mock_success(inputs)
	if (locale === "ar") return ar_shipping_label_mock_success(inputs)
	if (locale === "id") return id_shipping_label_mock_success(inputs)
	if (locale === "it") return it_shipping_label_mock_success(inputs)
	if (locale === "ru") return ru_shipping_label_mock_success(inputs)
	if (locale === "pt") return pt_shipping_label_mock_success(inputs)
	return ko_shipping_label_mock_success(inputs)
});